var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_276)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6956 0.99981L32.9999 10.8515V29.1477L17.6956 38.9997L0.99984 29.1126V10.8571L17.6956 0.99981Z",
    fill: "#FEFEFE",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 0.579385L17.7069 0.412473L17.4413 0.569252L0.745635 10.4265L0.49984 10.5716V10.8571V29.1126V29.3976L0.745067 29.5429L17.4408 39.4299L17.7065 39.5872L17.9662 39.4201L33.2705 29.5682L33.4999 29.4205V29.1477V10.8515V10.5787L33.2705 10.431L17.9662 0.579385Z",
    stroke: "#FEFEFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0363 14.0054H24.0241V16.0115H25.9998V17.0146H24.0241V19.0199H23.0363V17.0146H21.0605V16.0115H23.0363V14.0054ZM17.6984 14.765C18.1111 15.1112 18.9725 15.84 18.9725 17.226C18.9725 18.5741 18.2185 19.213 17.4645 19.8138L17.4377 19.8409C17.2108 20.0699 16.9618 20.3212 16.9618 20.7074C16.9618 21.1023 17.2232 21.3201 17.4197 21.4838L17.4282 21.491L18.0754 22.0005C18.8652 22.6751 19.5829 23.2955 19.5829 24.5533C19.5829 26.2663 17.9487 27.9979 14.8612 27.9979C12.2574 27.9979 11.0012 26.7405 11.0012 25.3912C11.0012 24.7343 11.3236 23.8062 12.3841 23.1673C13.4743 22.4887 14.9457 22.3878 15.7641 22.3317L15.8129 22.3284L15.7792 22.2846C15.5361 21.9694 15.2739 21.6293 15.2739 21.0895C15.2739 20.8121 15.3467 20.6367 15.426 20.4456L15.4261 20.4455C15.4352 20.4235 15.4444 20.4013 15.4536 20.3787L15.4484 20.3792C15.252 20.3972 15.0573 20.4152 14.8789 20.4152C12.9762 20.4152 11.8988 18.975 11.8988 17.5545C11.8988 16.7159 12.2764 15.7852 13.0476 15.1112C14.0714 14.2547 15.2918 14.109 16.2619 14.109H19.9599L18.8109 14.765H17.6984ZM16.4228 22.8582C16.2798 22.8391 16.1898 22.8391 16.011 22.8391C15.8491 22.8391 14.8789 22.8761 14.125 23.1319C13.7301 23.2773 12.5814 23.7141 12.5814 25.0086C12.5814 26.3028 13.8206 27.2326 15.7415 27.2326C17.4645 27.2326 18.3809 26.3929 18.3809 25.2646C18.3809 24.3331 17.7883 23.8421 16.4228 22.8582ZM16.9438 19.395C17.3566 18.975 17.3924 18.3922 17.3924 18.064C17.3924 16.7515 16.6206 14.7103 15.1308 14.7103C14.6635 14.7103 14.1614 14.9472 13.8733 15.3119C13.5682 15.6951 13.4788 16.1864 13.4788 16.6611C13.4788 17.8815 14.1791 19.9048 15.7235 19.9048C16.1721 19.9048 16.6558 19.6864 16.9438 19.395Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_276",
    x: -0.000244141,
    y: -0.174805,
    width: 36,
    height: 43.8496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_276",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f52c0aeb2ecc026f099ee80c3f79d5de.svg";
export { ForwardRef as ReactComponent };